import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Paper, IconButton } from "@mui/material";
import { ContentCopy as CopyIcon } from "@mui/icons-material";
import { JsonView } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import "./styles.css";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function JsonViewer({ data }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: "rgba(0, 0, 0, 0.02)",
        borderRadius: 1,
        fontFamily: "monospace",
      }}
    >
      <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MDTypography variant="h6" fontWeight="medium">
          Extracted Data
        </MDTypography>
        <IconButton onClick={handleCopy} size="small" title="Copy to clipboard">
          <CopyIcon fontSize="small" />
        </IconButton>
      </MDBox>
      <Box
        sx={{
          fontSize: "0.875rem",
          height: "calc(100vh - 300px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <JsonView
          data={data}
          shouldExpandNode={() => true}
          style={{
            container: "json-container",
            basicChildStyle: "json-basic-child",
            punctuation: "json-punctuation",
            propertyKey: "json-property-key",
            propertyValueString: "json-property-string",
            propertyValueNumber: "json-property-number",
            propertyValueBoolean: "json-property-boolean",
            propertyValueNull: "json-property-null",
            propertyValueUndefined: "json-property-undefined",
            propertyValueFunction: "json-property-function",
          }}
        />
      </Box>
      {copied && (
        <MDTypography
          variant="caption"
          color="success"
          sx={{ position: "absolute", right: 16, top: 16 }}
        >
          Copied!
        </MDTypography>
      )}
    </Paper>
  );
}

JsonViewer.propTypes = {
  data: PropTypes.any.isRequired,
};

export default JsonViewer;
